<template>
    <div v-if="$store.state.settings.activeTab === 'Settings_Module'">
        <v-row class="d-flex justify-center">
            <v-col cols="12" lg="10" xl="9">
                <Datatable :headers="tableHeaders" :items="modules" title="Module" :items-per-page="-1"
                           @click:row="emitClicked($event, true)"
                           @click:delete="emitClicked($event, true)"
                >
                    <template #top>
                        <div class="text-body-1">Verwaltung erfolgt über das Git</div>
                    </template>
                </Datatable>
            </v-col>
        </v-row>
        <DeleteModuleDialog v-model="showDeleteDialog"></DeleteModuleDialog>
    </div>
</template>

<script>
import Datatable from "../../../components/Tables/Datatable";
import ada from "../../../scss/ada_colors.scss";
import Utils from "../../../scripts/Utils";
import DeleteModuleDialog from "../Dialogs/DeleteModuleDialog";

export default {
    name: "Settings_Module",
    components: {DeleteModuleDialog, Datatable},
    data: () => {
        return {
            tableHeaders: [
                {text: 'Bezeichnung', value: 'Name'},
                {text: 'Erstellt am', value: 'created_at', width: '250px'},
                {text: 'Aktion', value: 'action', width: '100px', sortable: false},
            ],
            showDeleteDialog: false,
            ada
        }
    },
    mounted() {
    },
    computed: {
        vuexState() {
            return this.$store.state.settings;
        },
        modules() {
            let modules = this.vuexState.modules ? this.vuexState.modules : [];
            modules.forEach((item) => {
                item.created_at = Utils.formatDate(item.Created, true);
                item.action = ['delete'];
            })
            return modules;
        }
    },
    methods: {
        emitClicked(item, deleting = false) {
            this.$emit('click', item, deleting, this);
        },
    },
}
</script>

<style scoped>

</style>